import PHPURL from '../reducers/ReducerPHPURL';
import { selectOption } from './selectOption';
import { getSubTable } from './getSubTable';

export const submitCellUpdate = (updateData, option, phpSubComponent) => {

    let phpPath = PHPURL.baseURL + PHPURL.updateData;

    return function (dispatch) {

        fetch(phpPath, {
            method: "POST",
            body: updateData
        })
            .then(response => response.json())
            .then(data => {
                if (data.error) {
                    alert(data.error)
                } else {
                    dispatch({
                        type: "UPDATE_SUBMITTED"
                    });
                    if (phpSubComponent) {
                        dispatch(
                            getSubTable(phpSubComponent)
                        )
                    } else {
                        dispatch(
                            selectOption(option)
                        )
                    }
                }
            })
            .catch((error) => {
                dispatch({
                    type: "UPDATE_SUBMITTED",
                    payload: error
                })
            })
    }
};


// WEBPACK FOOTER //
// ./src/actionCreators/submitCellUpdate.js